/**
 * Converts arrays created by jQuerys serializeArray, to
 * key:value-pairs. Supports one level of depths with
 * no-named [] and two levels with named [named][brackets]
 *
 * usage:
 *
 * var dataArray = $('form').serializeArray();
 * var dataObject = convertFormData(dataArray);
 *
 * Uses Array.prototype.reduce
 *
 * Should work in all modern browsers and IE9+
 *
 * Use polyfill for old browsers
 *
 */

/**
 * Setup for use with AMD, CommonJs and Browser
 */

(function (root, factory) {
  'use strict';
  if (typeof define === 'function' && define.amd) {
    define('modules/form/convert-form-data',factory);
  } else if (typeof exports === 'object') {
    module.exports = factory();
  } else {
    root.convertFormData = factory();
  }

}(this, function () {
  'use strict';
  var reg = /([a-zA-Z0-9_-]+)\[([a-zA-Z0-9_-]+)\]\[([a-zA-Z0-9_-]+)\]/;
  return function(formArray) {
    return  formArray.reduce(function (memo, field) {
      var name, matches;

      matches = field.name.match(reg);

      if (matches) {
        name = matches[1];
        memo[name] = memo[name] || {};
        memo[name][matches[2]] = memo[name][matches[2]] || {};
        memo[name][matches[2]][matches[3]] = field.value;
      }
      else if (field.name.indexOf('[]') !== -1) {
        name = field.name.replace('[]', '');
        memo[name] = memo[name] || [];
        memo[name].push(field.value);

      } else {
        memo[field.name] = field.value;
      }
      return memo;

    }, {});
  };
}));
